import { Controller } from '@hotwired/stimulus';
import { FetchRequest } from '@rails/request.js'

export default class extends Controller {
  static targets = ["codeInput", 'mailSent', 'resend']
  static classes = ['hidden', 'visible']
  static values = {
    resendUrl: String
  }

  async resend () {
    await this.createVerificationCode(this.element.dataset.unverifiedEmail)

    this.mailSentTarget.classList.add(this.visibleClass)
    this.mailSentTarget.classList.remove(this.hiddenClass)

    this.resendTarget.classList.remove(this.visibleClass)
    this.resendTarget.classList.add(this.hiddenClass)
  }

  async createVerificationCode (email) {
    const request = new FetchRequest('post', this.resendUrlValue, {
      body: {
        subject: email
      },
    })

    await request.perform()
  }
}
